import { ReportPendingService } from './../../services/report-pending/report-pending.service';
import { GeneralService } from './../../services/admin/general.service';
import { Component, OnInit, ViewChild, Input, Injectable, Inject } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../services/storage.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { User } from '../../models/user';
import { ENPOINT } from './../../services/endpoint';
import { GLOBAL } from './../../services/global';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { ResponseModalComponent } from './../../components/response-modal/response-modal.component';
import { ResponseModal2Component } from './../../components/response-modal2/response-modal2.component';



const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};


@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }



}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}



@Component({
  selector: 'app-reportpending',
  templateUrl: './report-pending.component.html',
  styleUrls: ['./report-pending.component.scss'],
  providers: [GeneralService, CatalogsService, ReportPendingService,
    I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class ReportPendingComponent implements OnInit {
  public user: User;
  private basePath;
  url: string;
  rows = [];
  selected = [];
  @ViewChild('mydatatable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  fechaInicio;
  fechaFinal;
  sociedadOpt = '';
  proveedorOpt = '';
  neaOpt = '';
  ordenCompraOpt = '';
  deOpt = '';
  aOpt = '';
  dcOpt = '';
  tipoFacturaOpt = '';
  referenciaOpt = '';
  masterFacturas;
  numFacturasProcesadas: any = 0;
  docPdf;
  docXml;
  salida = {
    masterFactura: []
  };
  flagDescargaZip = false;
  editing = {};
  editClicked = null;
  closeResult: string;
  modalConfirmacion;
  uuidSeleccionado;
  modalFilters;
  masterFacts = [];
  proveedores;
  sociedades;
  mostrarxml = false;
  loadingExcel = false;

  proveedorFilter = "";
  sociedadFilter = "";
  ordenCompraFilter = "";
  referenciaFilter = "";
  neaFilter = "";
  tipoFacturaFilter = "";
  documentoFilter = "";

  fechaHoy;
  fechaAnterior;
  tituloCerrarComplemento;
  mensajeCerrarComplemento;
  tituloCerrarComp;
  titulo;
  mensaje1;

  tipoFactura = [
    { id: 'SOC', name: 'Financiera' },
    { id: 'OC', name: 'Logística' }
  ];

  proveedores$: Observable<any>;
  proveedoresLoadig = false;
  proveedorinput$ = new Subject<string>();

  sociedades$: Observable<any>;
  sociedadesLoadig = false;
  sociedadinput$ = new Subject<string>();

  busy: boolean = false;
  busyReload: boolean = false;
  busyBusqueda: boolean = false;

  flagBusqueda = false; flagMensaje;

  toastRangoFechasValido;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  constructor(private translate: TranslateService,
    private general: GeneralService,
    private catalogs: CatalogsService,
    private storageService: StorageService,
    private ReportPendingService: ReportPendingService,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {
    this.url = GLOBAL.url;
    this.basePath = ENPOINT.url;

    this.getProveedores();
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.rangoFechasValido').subscribe(
      text => {
        this.toastRangoFechasValido = text;
      });
    this.translate.get('texto.cerrarComplementoTitulo').subscribe(
      text => {
        this.tituloCerrarComplemento = text;
      });
    this.translate.get('texto.cerrarComplementoMensaje').subscribe(
      text => {
        this.mensajeCerrarComplemento = text;
      });
    this.translate.get('texto.tituloCerrarComplemeto').subscribe(
      text => {
        this.tituloCerrarComp = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.modulo();
    // this.getSociedades();
    this.getMasterFacturas();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Complementos pendientes').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  getProveedores() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoadig = true),
        switchMap(term =>
          this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoadig = false)
          ))
      )
    );
  }


  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    if (this.selected.length > 0) {
      this.flagDescargaZip = true;
    } else {
      this.flagDescargaZip = false;
    }
  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
    this.editClicked = false;
  }



  getMasterFacturas() {
    this.busy = true;
    this.selected = [];
    /* Fecha actual */
    var hoy: any = new Date();
    var dd: any = hoy.getDate();
    var mm: any = hoy.getMonth() + 1;
    var yyyy = hoy.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    var fechaHoy = yyyy + '-' + mm + '-' + dd;

    /* Fecha 15 dias antes */
    let dieciseisDias = 1000 * 60 * 60 * 24 * 15;
    let resta = hoy.getTime() - dieciseisDias;
    let fechaAtras = new Date(resta);

    var ddAtras: any = fechaAtras.getDate();
    var mmAtras: any = fechaAtras.getMonth() + 1;
    var yyyyAtras: any = fechaAtras.getFullYear();

    if (ddAtras < 10) {
      ddAtras = '0' + ddAtras;
    }

    if (mmAtras < 10) {
      mmAtras = '0' + mmAtras;
    }

    var fechaAnterior = yyyyAtras + '-' + mmAtras + '-' + ddAtras;

    this.fechaInicio = fechaAnterior;
    this.fechaFinal = fechaHoy;
    this.proveedorFilter = "";
    this.documentoFilter = "";
    this.ReportPendingService.obtenerMasterFacturasPro(this.proveedorFilter, fechaAnterior, fechaHoy, this.documentoFilter).subscribe(
      data => {
        this.busy = false;

        if (data != null) {
          this.masterFacturas = data.masterFactura; 
          this.rows = this.masterFacturas;
          this.numFacturasProcesadas = this.masterFacturas.length;

          if (this.masterFacturas.length > 0) {
            this.mostrarxml = true;
          } else {
            this.mostrarxml = false;
          }
        }

      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  reload() {
    this.busy = true;
    var proveedor, noDocPago = '';

    if (this.user.rol.id == 3) {
      proveedor = this.user.rol.id;
    }

    this.proveedorFilter = proveedor;
    this.busyReload = true;
    this.rows = [];
    this.ReportPendingService.obtenerMasterFacturasPro(this.proveedorFilter, this.fechaInicio, this.fechaFinal, this.documentoFilter).subscribe(
      data => {
        this.busyReload = false;
        this.masterFacturas = data.masterFactura;
        this.rows = this.masterFacturas;
        this.numFacturasProcesadas = this.masterFacturas.length;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  getXmlReporte() {
    const params = '?provedor=' + this.proveedorFilter + '&fechai=' + this.fechaInicio +
      '&fechaf=' + this.fechaFinal + '&noDocPago=' + this.documentoFilter + '&estatus=Pagada';

    this.loadingExcel = true;

    this.ReportPendingService.downloadExcelReport(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reporte-complementos-pendientes.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        console.error('Error al descargar el reporte:', error);
      },
      () => {
        this.loadingExcel = false;
      }
    );
  }



  descargaPdf(value) {
    this.docPdf = value; 
    this.getPdf();
  }

  getPdf() {
    const srcFile = this.docPdf;

    if (srcFile) {
      const srcB64 = btoa(srcFile);

      this.ReportPendingService.downloadPdf(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Documento.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el PDF:', error);
        }
      );
    } 
  }

  descargaXml(value) {
    this.docXml = value;
    this.getXml();
  }

  getXml() {
    const srcFile = this.docXml;

    if (srcFile) {
      const srcB64 = btoa(srcFile);

      this.ReportPendingService.downloadXml(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Documento.xml`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el XML:', error);
        }
      );
      
    } else {
      // console.log('El registro no contiene archivo XML.');
    }
  }

  descargarZip() {
    // console.log(this.selected);
    this.salida.masterFactura = [];

    for (let i = 0; i < this.selected.length; i++) {

      let xmlDoc;
      if (this.selected[i].xml !== '') {
        xmlDoc = this.selected[i].xml;
      } else {
        xmlDoc = '';
      }

      let pdfDoc;
      if (this.selected[i].pdf !== '') {
        pdfDoc = this.selected[i].pdf;
      } else {
        pdfDoc = '';
      }

      const objectFacturas = {
        pdf: pdfDoc,
        xml: xmlDoc
      };

      this.salida.masterFactura.push(objectFacturas);
    }

    this.ReportPendingService.obtenerZip(this.salida).subscribe(
      data => {
        const respuesta = data.result.mensaje;
        const win = window.open('data:application/zip;base64,' + respuesta, '_blank');
        if (win) {
          win.focus();
        } else {
          alert('Por favor activa los popups en tu navegador');
        }
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          console.log(err);
        }
      },
    );
  }

  btnEditar() {
    this.editClicked = true;
  }

  btnCancelarEdit() {
    this.editClicked = false;
  }

  guardarEdicion() {
    const estatus = (<HTMLSelectElement>document.getElementById('estatus')).value;

    this.ReportPendingService.cambiarStatus(this.uuidSeleccionado, estatus).subscribe(
      data => {
        this.editClicked = false;
        const mensaje = data.result.message;
        let estado = data.result.status;
        if (estado === 'S') {
          estado = '';
          this.toasterService.pop('success', estado, mensaje);
        } else {
          estado = 'Error';
          this.toasterService.pop('error', estado, mensaje);
        }

        this.masterFacturas = '';
        this.rows = [];
        this.numFacturasProcesadas = '';
        //  this.getMasterFacturas();

        this.modalConfirmacion.close();
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          console.log(err);
        }
      },
    );
  }

  openConfirmacion(confirmacion, row) {
    this.uuidSeleccionado = row.uuid;
    this.modalConfirmacion = this.modalService.open(confirmacion, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalConfirmacion.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openFilters(filtersCheckInv) {

    this.modalFilters = this.modalService.open(filtersCheckInv, { centered: true });
    this.modalFilters.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFilters(reason)}`;
    });
  }

  private getDismissReasonFilters(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  buscarFacturas() {
    this.busyBusqueda = true;
    let proveedor = this.proveedorFilter;
    var noDocPago = '';
    let fechaI = (<HTMLInputElement>document.getElementById('fechaiOpt')).value;
    let fechaF = (<HTMLInputElement>document.getElementById('fechafOpt')).value;
    this.fechaInicio = fechaI;
    this.fechaFinal = fechaF;

    if (proveedor == null || fechaI === '' || fechaF === '') {
      this.flagMensaje = true;
      this.flagBusqueda = false;
    } else {
      if (fechaI <= fechaF) {
        this.flagMensaje = false;
        this.flagBusqueda = true;
      } else {
        this.toasterService.pop('error', 'ERROR', this.toastRangoFechasValido);
        this.flagBusqueda = false;
      }
    }

    this.fechaInicio = fechaI;
    this.fechaFinal = fechaF;

    if (this.flagBusqueda) {
      this.ReportPendingService.obtenerMasterFacturasPro(proveedor, this.fechaInicio, this.fechaFinal, noDocPago).subscribe(
        data => {
          this.busyBusqueda = false;
          if (data !== null) {
            this.masterFacturas = data.masterFactura;
            this.numFacturasProcesadas = this.masterFacturas.length;
            this.rows = [];
            this.rows = this.masterFacturas;
            this.modalFilters.close();

            this.numFacturasProcesadas = this.masterFacturas.length;
            if (this.masterFacturas.length > 0) {
              this.mostrarxml = true;
            } else {
              this.mostrarxml = false;
            }
          }


        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout();
          } else {
            console.log(err);
          }
        },
      );
    } else {
      this.busyBusqueda = false;
    }

  }

  cerrarComplementos(uuid) {
    const modalRef = this.modalService.open(ResponseModalComponent, { centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.titulo = this.tituloCerrarComplemento;
    modalRef.componentInstance.mensaje1 = this.mensajeCerrarComplemento;

    modalRef.result.then((result) => {
      if (result === 'aceptar') {

        this.ReportPendingService.cerrarComplemento(uuid).subscribe(
          data => {
       
            if (data !== null) {

              if (data.result.status == 'S') {
                this.titulo = this.tituloCerrarComp;
              } else {
                this.titulo = this.tituloCerrarComp;
              }

              this.mensaje1 = data.result.message;

              const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
              modalRef.componentInstance.titulo = this.titulo;
              modalRef.componentInstance.mensaje1 = this.mensaje1;

              modalRef.result.then((result) => {
                // console.log(result);
              });
            }
          },
          err => {

            if (err.status === 401) {
              this.storageService.openLogout();
            } else {
              console.log(err);
            }
          },
        );

      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/report-pending/report-pending.component.ts